import React, { useEffect, useState } from "react";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { BrowserRouter, Route, Routes } from "react-router-dom";
// import ReactGA from 'react-ga';
import KeycloakAuth from "./helpers/KeycloakAuth"
import PublicRoute from "./helpers/PublicRoute";
import PrivateRoute from "./helpers/PrivateRoute";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Registo from "./pages/Registo";
import RecuperarPassword from "./pages/RecuperarPassword";
import Ajuda from "./pages/Ajuda";
import Dashboard from "./pages/Dashboard";
import ExtratoIndividual from "./pages/ExtratoIndividual";
import ExtratoConsolidado from "./pages/ExtratoConsolidado";
import Pedido from "./pages/Pedido";
import DadosPessoais from "./pages/DadosPessoais";

const TRACKING_ID = "UA-220438183-5";

/* DESABILITAR GOOGLE ANALYTICS */
// ReactGA.initialize(TRACKING_ID);

function App() {
  useEffect(() => {
    /* DESABILITAR GOOGLE ANALYTICS */
    // ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <div>
      <ReactKeycloakProvider initOptions={{ onLoad: 'check-sso', checkLoginIframe: false }} authClient={KeycloakAuth}>
        {/* <React.StrictMode> */}
          <Header />
          <BrowserRouter>
            <Routes>
              <Route
                path="/"
                element={
                  <PublicRoute>
                    <Home />
                  </PublicRoute>
                }
              />
              <Route
                path="/registo"
                element={
                  <PublicRoute>
                    <Registo />
                  </PublicRoute>
                }
              />
              <Route
                path="/recuperarpassword"
                element={
                  <PublicRoute>
                    <RecuperarPassword />
                  </PublicRoute>
                }
              />
              <Route
                path="/ajuda"
                element={
                    <Ajuda />
                }
              />
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/extratoindividual"
                element={
                  <PrivateRoute>
                    <ExtratoIndividual />
                  </PrivateRoute>
                }
              />
              <Route
                path="/extratoindividual/:id"
                element={
                  <PrivateRoute>
                    <ExtratoIndividual />
                  </PrivateRoute>
                }
              />
              <Route
                path="/extratoconsolidado"
                element={
                  <PrivateRoute>
                    <ExtratoConsolidado />
                  </PrivateRoute>
                }
              />
              <Route
                path="/registarpedido"
                element={
                  <PrivateRoute>
                    <Pedido />
                  </PrivateRoute>
                }
              />
              <Route
                path="/dadospessoais"
                element={
                  <PrivateRoute>
                    <DadosPessoais />
                  </PrivateRoute>
                }
              />
            </Routes>
          </BrowserRouter>
          <Footer />
        {/* </React.StrictMode> */}
     </ReactKeycloakProvider>
   </div>
  );
}

export default App;
